'use client'

import { Box, Heading, Text } from '@chakra-ui/react'
import { FC } from 'react'

export type DealCardProps = {
  title: string
  description: string
}

export const DealCard: FC<DealCardProps> = ({ title, description }) => {
  return (
    <Box
      bg="background.default"
      border="1px solid"
      borderColor="border.default"
      borderRadius="card"
      p={{ base: 6, md: 10 }}
    >
      <Heading
        as="h3"
        fontFamily="heading"
        fontSize="1.2rem"
        fontWeight={500}
        mb={2}
        color="teal.500"
      >
        {title}
      </Heading>
      <Text color="text.secondary" lineHeight={1.6}>
        {description}
      </Text>
    </Box>
  )
}
